/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Public_HintInputs */

const cs_settings_profile_public_hint = /** @type {(inputs: Settings_Profile_Public_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazí se na veřejném webu, pokud je zapnuto.`)
};

const en_settings_profile_public_hint = /** @type {(inputs: Settings_Profile_Public_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown on the public website when enabled.`)
};

/**
* | output |
* | --- |
* | "Shown on the public website when enabled." |
*
* @param {Settings_Profile_Public_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_public_hint = /** @type {((inputs?: Settings_Profile_Public_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Public_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_public_hint(inputs)
	return cs_settings_profile_public_hint(inputs)
});